import { TabItem } from './TabItem';
import { TabList } from './TabList';
import { TabPanel } from './TabPanel';
import React, { createContext, useEffect, useState } from 'react';

export const TabsContext = createContext<{
  selected: string | number | undefined;
  setSelected: React.Dispatch<React.SetStateAction<string | number | undefined>>;
  controlled: boolean;
} | null>(null);

export type TabsProps = {
  /**
   * Optional value, string set to the value of the initially selected item
   */
  value?: string | number;
  /**
   * Optional controlled, boolean used to set the controlled state of the component to controlled or uncontrolled. Defaults to controlled.
   */
  controlled?: boolean;
  /**
   * Optional onChange, function used to set the value for the Tabs component
   */
  onChange?: (value: string | number) => void;
} & React.HTMLAttributes<HTMLDivElement>;

const TabsRoot = ({ children, value, onChange, controlled = true, ...rest }: TabsProps) => {
  const [selected, setSelected] = useState<string | number | undefined>(value);
  const contextValue = { selected, setSelected, controlled };

  useEffect(() => {
    setSelected(value);
  }, [value, setSelected]);

  useEffect(() => {
    onChange && !controlled && selected && onChange(selected);
  }, [selected, onChange, controlled]);

  return (
    <div {...rest}>
      <TabsContext.Provider value={contextValue}>{children}</TabsContext.Provider>
    </div>
  );
};

/**
 * @deprecated Deprecated — use pantry Tabs instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-tabs--docs
 * Migration: Replace Tabs with the pantry Tabs component.
 */
export const Tabs = Object.assign(TabsRoot, {
  Item: TabItem,
  Panel: TabPanel,
  List: TabList,
});
